import gsap from "gsap";

const setHeaderFixed = () => {
  const header = document.querySelector('#site-header');

  function setHeaderAnimIn() {
    gsap.timeline()
    .fromTo(header, {
      autoAlpha: 0,
      yPercent: -100,
    }, {
      autoAlpha: 1,
      yPercent: 0,
      duration: .3,
    })
  }

  function setHeaderAnimOut() {
    gsap.timeline()
    .to(header, {
      autoAlpha: 0,
      duration: .2,
      onComplete: () => {
        header.classList.remove('is-fixed')
      }
    })
  }

  var scroll_y = window.scrollY;

  if(scroll_y > 300) {
    if(!header.classList.contains('is-fixed')) {
      header.classList.add('is-fixed')
      setHeaderAnimIn()
    }
  } else {
    header.classList.remove('is-fixed')
  }

  window.addEventListener('scroll', (event) => {
    scroll_y = window.scrollY;

    if(scroll_y > 300) {
      if(!header.classList.contains('is-fixed')) {
        header.classList.add('is-fixed')
        setHeaderAnimIn()
      }
    } else {
      header.classList.remove('is-fixed')
    }
  });
};

export default setHeaderFixed;
